import { FeedbackAlert } from '../app/FeedbackAlert.tsx';
import { Page } from '../components/page/Page.tsx';
import { usePageView } from '../support/tracking/usePageView.tsx';
import { MissionList } from './components/MissionList.tsx';

export const MissionListPage = () => {
    usePageView('Missions');

    return (
        <Page title="Missions"  >
            <FeedbackAlert />
            <MissionList />
        </Page>
    );
};
